import { useCallback } from 'react';
import { toasterApi } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { openWebAppPage } from '../utils/openWebAppPage';

export function useOpenWebAppPage() {
  const t = useTranslations('settings.targetSettings');

  return useCallback(
    (path: string) => {
      openWebAppPage(path).catch((error: unknown) => {
        console.error(
          new Error(`Failed to open web app page ${path}`, {
            cause: error instanceof Error ? error : new Error(String(error)),
          }),
        );
        toasterApi.error({
          title: t('openWebAppError'),
          description: error instanceof Error ? error.message : undefined,
        });
      });
    },
    [t],
  );
}
